import { render, staticRenderFns } from "./companyUser.vue?vue&type=template&id=d06bc50c&scoped=true&"
import script from "./companyUser.vue?vue&type=script&lang=js&"
export * from "./companyUser.vue?vue&type=script&lang=js&"
import style0 from "./companyUser.vue?vue&type=style&index=0&id=d06bc50c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06bc50c",
  null
  
)

export default component.exports